/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface ProvinceDTO { 
    /**
     * The unique code associated to province 
     */
    code?: string;
    /**
     * The study's creation date
     */
    createDate?: Date;
    /**
     * The ceate user's uuid
     */
    createUserId?: string;
    /**
     * The description associated to study 
     */
    description?: string;
    /**
     * The study's update date
     */
    updateDate?: Date;
    /**
     * The update user's uuid
     */
    updateUserId?: string;
    /**
     * The study's uuid
     */
    uuid?: string;
}
